import type { AdminEmployeeCsatScore } from "../modules/types";
import { adminApiGet } from "./utils";

export const adminEmployeeCsatScoresApi = {
  getAll: (workspaceId?: string): Promise<AdminEmployeeCsatScore[]> =>
    adminApiGet<AdminEmployeeCsatScore[]>(
      workspaceId
        ? `/employee_csat_scores?workspace_id=${encodeURIComponent(workspaceId)}`
        : "/employee_csat_scores",
    ),

  getById: (id: string): Promise<AdminEmployeeCsatScore> =>
    adminApiGet<AdminEmployeeCsatScore>(`/employee_csat_scores/${id}`),
};
